import { render, staticRenderFns } from "./AbandonmentSettings.vue?vue&type=template&id=26a5b0cc&"
import script from "./AbandonmentSettings.vue?vue&type=script&lang=js&"
export * from "./AbandonmentSettings.vue?vue&type=script&lang=js&"
import style0 from "./AbandonmentSettings.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/contactum-new/contactum-new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('26a5b0cc')) {
      api.createRecord('26a5b0cc', component.options)
    } else {
      api.reload('26a5b0cc', component.options)
    }
    module.hot.accept("./AbandonmentSettings.vue?vue&type=template&id=26a5b0cc&", function () {
      api.rerender('26a5b0cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/admin/components/settings/AbandonmentSettings.vue"
export default component.exports